/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import React from 'react';
import { cn } from '@/shared/ui/utils/tailwind';

export type FormProps = React.FormHTMLAttributes<HTMLFormElement> & {
  className?: string;
};

/**
 * Thin DS wrapper around the native `<form>` element.
 * Use this instead of raw `<form>` to satisfy DS compliance rules.
 */
export const Form = React.forwardRef<HTMLFormElement, FormProps>(
  ({ className, ...props }, ref) => (
    <form ref={ref} className={cn(className)} {...props} />
  ),
);

Form.displayName = 'Form';

export default Form;
